import { AiOutlineDelete } from 'react-icons/ai'
import { Button, Heading, IconButton, Spinner, Text, useToast } from '@chakra-ui/react'
import { DataView, IDataViewColumn } from '../../common/dataview/DataView'
import { FiEdit2 } from 'react-icons/fi'
import { GetAdmins, useDeleteAdminMutation } from '../../../api/calls/admin/AdminQueries'
import { IAdmin } from '../../../models/Admin'
import { NavLink } from 'react-router-dom'
import { useModal } from '../../../context/ModalContext'
import { useQuery, useQueryClient } from 'react-query'
import { useState } from 'react'

export default function AdminList() {
  const { dispatch } = useModal();
  const toast = useToast();

  const [columns] = useState<IDataViewColumn[]>([
    { headerName: "FirstName", field: "firstName", flex: 0.5 },
    { headerName: "EmailAddress", field: 'email', flex: 1 },
    { headerName: "Username", field: 'userName', flex: 1 },
    { headerName: "Last activity", field: 'lastActivity', flex: 1, cellRenderer: 'renderdatetime' },
    { headerName: "Actions", cellRenderer: 'actions', flex: 0.5 },
  ]);
  const queryClient = useQueryClient();
  const handleDeleteAdmin = useDeleteAdminMutation();
  const { data, isLoading } = useQuery(['admins'], GetAdmins);

  const handleDelete = (id: string) => {
    handleDeleteAdmin.mutate(id, {
      onSuccess() {
        queryClient.invalidateQueries(["admins"])
        dispatch({ type: 'close' })
        toast({
          title: "Admin Deleted",
          status: "success",
          duration: 10 * 1000,
          isClosable: true,
          position: "top",
        })
      },
      onError() {
        toast({
          title: "Error deleting admin",
          status: "error",
          duration: 10 * 1000,
          isClosable: true,
          position: "top"
        })
      }
    })
  }

  const renderCellAction = (tableData: any) => {
    const admin: IAdmin = tableData.data;
    return (
      <>
        <IconButton
          icon={<FiEdit2 fontSize="1.25rem" />}
          aria-label='Edit admin'
          as={NavLink}
          to={`edit/${admin.id}`}
        />
        <IconButton
          icon={<AiOutlineDelete fontSize="1.25rem" />}
          aria-label="Delete admin"
          color="red"
          onClick={() => dispatch({
            type: 'open', payload: {
              title: "Delete admin",
              bodyContent: <>
                <Text>Are you sure you want to delete the admin?</Text>
              </>,
              footerContent:
                <>
                  <Button mr={3} color="red" onClick={() => handleDelete(admin.id)}>Delete</Button>
                  <Button onClick={() => dispatch({ type: 'close' })}>Close</Button>
                </>
            }
          })}
        />
      </>
    )
  }

  if (isLoading) return <Spinner />
  if (!isLoading && !data) return <Heading as="h1">No admins found.</Heading>

  return (
    <DataView
      actionsRenderer={renderCellAction}
      columns={columns}
      data={data}
    />
  );
}